import cloneDeep from 'lodash.clonedeep';
import uuid from 'uuid/v4';

export default function createSceneClipboardPayload(scribe, sceneIds) {
  const elementClones = [];
  const scenesToClone = scribe.scenes.filter(scene => sceneIds.includes(scene.id));
  const sceneClones = scenesToClone.map(scene => {
    const sceneClone = cloneDeep(scene);
    delete sceneClone.id;
    delete sceneClone.active;

    sceneClone.elementIds.forEach((elementId, index, arr) => {
      const elementClone = cloneDeep(scribe.elements.find(el => el.id === elementId));
      delete elementClone.id;

      elementClone.tempId = uuid();
      arr[index] = elementClone.tempId;
      elementClones.push(elementClone);
    });

    return sceneClone;
  });

  return {
    type: 'scene',
    metadata: {
      elements: elementClones,
      canvasSize: scribe.canvasSize
    },
    data: sceneClones
  };
}
